import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy } from '@angular/core';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent implements AfterViewInit, OnDestroy {
  private _intersectionObserver: IntersectionObserver | undefined;

  public companyLogoUrl$ = this.loadingService.loaderImageUrl$;

  constructor(
    private elementRef: ElementRef,
    private loadingService: LoadingService,
  ) {}

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

    this._intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add your logic here that should be executed when the component is fully visible.
          this.loadingService.setLoaderVisible();
        }
      });
    });

    this._intersectionObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
    }
  }
}
